module.exports = __webpack_public_path__ + "static/media/10UNOHRLLS10.edc12e74.jpg";